import type { AvailabilityReminder } from '@web-app/server/services/availability/availability-reminder.utils';

import { formatHoursAsDuration, formatShortDateRange } from './format.utils';

const EXCLUDED_ROUTES = [
  '/',
  '/calendar',
  '/settings',
  '/[roomId]',
  '/call',
  '/sign-in',
  '/sign-up',
  '/404',
  '/500',
  '/_error',
];

export const availabilityReminderTitle = (
  reminder: AvailabilityReminder,
): string =>
  reminder.noAvailability
    ? 'No availability scheduled'
    : 'Action Needed: Availability Commitment Not Met';

export const availabilityReminderDescription = (
  reminder: AvailabilityReminder,
): string => {
  if (reminder.noAvailability) {
    return `No open time or booked visits for ${formatShortDateRange(reminder.weeks[0].startDate, reminder.weeks[3].endDate)}. Add time in your calendar to accept appointments.`;
  }
  const hours = reminder.weeklyCommitmentHours ?? 0;
  const minimum = Number.isInteger(hours)
    ? `${hours}-hour weekly minimum`
    : `weekly minimum of ${formatHoursAsDuration(hours)}`;
  return `You are currently below your agreed ${minimum}. Please add more open time to close the gaps below.`;
};

/** Matches Next.js route patterns, including descendants of excluded pages. */
export const isAvailabilityReminderRouteExcluded = (route: string): boolean =>
  EXCLUDED_ROUTES.some(
    (excluded) => route === excluded || route.startsWith(`${excluded}/`),
  );
